import { List, ListItemButton, ListItemIcon, Popover, Typography } from '@mui/material';
import { JSX, MouseEvent, useState } from 'react';
import { useIntl } from 'react-intl';

import { HBIcon } from '../../../../HBIcon/HBIcon';
import { MenuItemProps } from '../../../HBGridHeader/HBGridHeader';
import { HBGridToolbarSubMenuWrapperStyle } from '../../HBGridToolbar.styles';
import { messages } from '../../messages';
import { HBGridToolbarItem, HBGridToolbarItemProps } from '../HBGridToolbarItem';

type HBGridMoreItemsProps = {
  items: MenuItemProps[] | undefined;
  moreProps: HBGridToolbarItemProps | undefined;
};

export function HBGridMoreItems(props: HBGridMoreItemsProps): JSX.Element {
  const { items, moreProps } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const { formatMessage } = useIntl();
  const id = open ? 'HBGridToolbarPopover' : undefined;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <HBGridToolbarItem
        icon="ellipsisH"
        tooltip={formatMessage(messages.more)}
        aria-describedby={id}
        onClick={handleClick}
        {...moreProps}
      />
      {items && items.length > 0 && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <HBGridToolbarSubMenuWrapperStyle>
            <List component="div" disablePadding>
              {items
                .filter(({ show = true, ...item }) => show)
                .map((item, index) => (
                  <ListItemButton
                    component="button"
                    disabled={item.disabled}
                    key={item?.id || index}
                    onClick={(event: MouseEvent<HTMLButtonElement>) => {
                      handleClose();
                      item.onClick?.(event);
                    }}
                    {...item}
                  >
                    {item.icon && (
                      <ListItemIcon>
                        {typeof item.icon === 'string' ? (
                          <HBIcon type={item.icon} size="small" />
                        ) : (
                          item.icon
                        )}
                      </ListItemIcon>
                    )}
                    <Typography variant="body1" component="span">
                      {item.label}
                    </Typography>
                  </ListItemButton>
                ))}
            </List>
          </HBGridToolbarSubMenuWrapperStyle>
        </Popover>
      )}
    </>
  );
}
